import { Col, Divider, Form, Row, Select } from "antd";
import { Option } from "antd/lib/mentions";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import useResolucaoQuestoes from "../../../core/hooks/UseResolucaoQuestoes";
import useUsuario from "../../../core/hooks/UseUsuario";
import { Banca, Materia } from "../../../sdk/@types";
import QuestaoService from "../../../sdk/services/QuestaoService";
import Button from "../Button/Button";
import * as SC from "./SessionController.styles";

export interface SessionControllerProps {
  name: string;
  description: string;
  onLogout?: () => any;
  bancas?: Banca.Banca[];
  materias?: Materia.Materia[];
}

function SessionController(props: SessionControllerProps) {
  const { usuario, usuarios, buscarUsuario, getUser } = useUsuario();

  const { buscarQuestoesAleatorias } = useResolucaoQuestoes();

  const [tags, setTags] = useState<String[]>([`SCI`, `2022`]);
  const [tagsConsulta, setTagsConsulta] = useState<String[]>([]);

  useEffect(() => {
   /* QuestaoService.buscarTagBancaAnoMateria().then((resultado) => {
      setTags(resultado);
    });*/
    getUser();
  }, []);

  useEffect(() => {}, [tags, tagsConsulta]);

  return (
    <SC.Wrapper>
      <SC.Avatar src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8YXZhdGFyfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80" />
      <SC.Name>{usuario?.userName}</SC.Name>
      <SC.Description>{props.description}</SC.Description>
      <Form>
        <Row>
          <Col style={{ width: "200px" }}>
            <Select
              mode="tags"
              placeholder={"Selecione ou informe um item..."}
              //maxTagCount={'responsive'}
              value={tagsConsulta}
              style={{ width: "100%" }}
              tokenSeparators={[", "]}
              onChange={(element) => {
                setTagsConsulta(element);
              }}
            >
              {tags?.map((elemento, index) => {
                return (
                  <React.Fragment key={index}>
                    <Option key={elemento.toString()}>{elemento}</Option>
                  </React.Fragment>
                );
              })}
            </Select>
          </Col>
        </Row>
      </Form>

      <NavLink to="/carrossel">
        <SC.Button>
          <Button
            onClick={() => {
              buscarQuestoesAleatorias({
                queryString: tagsConsulta,
                usuario: usuario,
              });
            }}
            label="Filtrar"
            variant="primary"
          />
          <Button
            onClick={async () => {
              await buscarQuestoesAleatorias({ usuario: usuario });
              setTagsConsulta([]);
            }}
            label="Limpar"
            variant="primary"
          />
        </SC.Button>
      </NavLink>

      <Button variant="danger" label="Logout" onClick={props.onLogout} />
    </SC.Wrapper>
  );
}

export default SessionController;
